import React, { Component } from 'react'

export class DeveloperDetails extends Component {
  render() {
    const details = this.props.details
    return (
      <div className='constainer-fluid'>
        <div className='col-xs-12 col-sm-6'>
          <label>
            <strong>Name</strong>
          </label>{' '}
          : &nbsp;
          <span>
            <small>{details.name}</small>
          </span>
        </div>
        <div className='col-xs-12 col-sm-6'>
          <label>
            <strong>GSTIN</strong>
          </label>{' '}
          : &nbsp;
          <span>
            <small>{details.gstin}</small>
          </span>
        </div>
        <div className='col-xs-12 col-sm-6'>
          <label>
            <strong>PAN</strong>
          </label>{' '}
          : &nbsp;
          <span>
            <small>{details.pan}</small>
          </span>
        </div>
        {details.addressDetails && details.addressDetails.length ? (
          <div className='col-xs-12'>
            {details.addressDetails.map(addr => (
              <p key={addr.id}>
                <label>{addr.type} address:</label>
                <small> {addr.address}</small>
              </p>
            ))}
          </div>
        ) : (
          ''
        )}
      </div>
    )
  }
}



/** WEBPACK FOOTER **
 ** ./src/components/Common/DeveloperDetails.js
 **/